import { Component } from '@angular/core';
import { soundpostReportOutputOrderPaymentLineEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Order Payment Lines') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputorderpaymentline-form',
    templateUrl: './soundpostreportoutputorderpaymentline.form.component.html'
})
export class soundpostReportOutputOrderPaymentLineFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputOrderPaymentLineEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

